module.exports = __webpack_public_path__ + "img/puzzled.aa6f61ed.png";